import {
    ABA,
    AIG,
    AXA,
    GNP,
    HDI,
    MAPFRE,
    PRIMEROSEGUROS,
    QUALITAS,
    ZURICH
} from "@modals/ModalAmpliaIntegral/Constants";

export const getInsurers = (type: string) => {
    switch (type) {
        case "AIG":
            return AIG
            break;
        case "AXA":
            return AXA
            break;
        case "ABA":
            return ABA
            break;
        case "GNP":
            return GNP
            break;
        case "HDI":
            return HDI
            break;
        case "MAPFRE":
            return MAPFRE
            break;
        case "PRIMEROSEGUROS":
            return PRIMEROSEGUROS
            break;
        case "QUALITAS":
            return QUALITAS
            break;
        case "ZURICH":
            return ZURICH
            break;
        default:
            return []
    }
}